module.exports = __webpack_public_path__ + "static/media/burger-checkmark.a1511e84.svg";